// extracted by mini-css-extract-plugin
export var cardHeader = "_es-0";
export var reorderHandle = "_es-3";
export var titleArea = "_es-1";
export var titleAreaWithHandle = "_es-2";